import { GET_ZONA_DETALLE, MODIFY_PRODUCTO_DE_ZONA, ADD_PRODUCTO_DE_ZONA, DELETE_PRODUCTO_DE_ZONA } from '../constants/action_types';

const initialState = {
    isLoading: true,
    zonaProductos: []
};;

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ZONA_DETALLE + "_SUCCESS":

            return {
                isLoading: false,
                zonaProductos: action.payload.data.productos
            };


        case ADD_PRODUCTO_DE_ZONA:

            const newArr = [...state.zonaProductos, action.payload]

            return {
                isLoading: false,
                zonaProductos: newArr,
            };

        case MODIFY_PRODUCTO_DE_ZONA:

            return {
                isLoading: false,
                zonaProductos: state.zonaProductos.map((productos) => {
                    if (productos.id !== action.payload.id) return productos;
                    else return action.payload;
                }),
            };

        case DELETE_PRODUCTO_DE_ZONA:

            return {
                isLoading: false,
                zonaProductos: state.zonaProductos.filter(productos => productos.id !== action.payload.id)
            };


        default:

            return state;
    }

}